export interface Profile {
    userId : string,
    email : string,
    roleId : string,
    name : string,
    normalizedName : string
    userName : string,
    normalizedUserName : string,
    active:boolean,
    companyId:number
}

export class PagedProfile{
    public succeeded !:boolean;
    public message !: string;
    public errors !: string;
    public data !: Profile[]
      
     }



     export class ActivateRole {
        userId! : string;
        roleId! : string;
    }
    